class footerAccordion extends HTMLElement {
  constructor() {
    super();

    if(this.classList.contains('admin-panel--no-js')) return;

	this.toggleContent = '.footer__accordion__content';
    this.boxes = this.querySelectorAll('.footer__accordion__heading');

    if(!this.boxes.length) return;
    this.bindEvents();
    this.resizeHandler();
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
  }
  bindEvents(){
    const _this = this;
    this.boxes.forEach(box => {
      box.addEventListener('click', event => {
        event.preventDefault();
        if(window.innerWidth > 576) return false;
        var details = event.target,
            childs = _this.querySelectorAll('[open]'),
            wasOpen = details.hasAttribute('open');
        if(details.hasAttribute('open')){
          details.classList.remove('footer__accordion-opening');
        }
        else{
          details.setAttribute('open', '');
          setTimeout(function(){
            _this.resizeHandler();
            details.classList.add('footer__accordion-opening');
          }, 0);
        }
        // I-TL2 16/10/2026 (DECISIONI-MAIN §121): screen readers hear which column is open
        _this.boxes.forEach(b => {
          if (b.hasAttribute('role')) b.setAttribute('aria-expanded', b === details && !wasOpen ? 'true' : 'false');
        });
        if(childs.lenght <= 0) return false;
        childs.forEach(child => {
          child.classList.remove('footer__accordion-opening');
          setTimeout(function(){
            child.removeAttribute('open');
          }, 300);
        });
      });
      // I-TL2 16/10/2026 (DECISIONI-MAIN §121): under 577 px the heading opens and closes with Enter and Space too
      box.addEventListener('keydown', event => {
        if(window.innerWidth > 576 || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        box.click();
      });
    });
  }
  resizeHandler(){
   	const boxes = this.querySelectorAll('[open]+'+this.toggleContent);
	boxes.forEach(box => {
      box.style.setProperty('--scroll-height', (box.scrollHeight+1) + "px");
    });
    // I-TL2 16/10/2026 (DECISIONI-MAIN §121): the heading is a button only where the accordion works (under 577 px)
    const mobile = window.innerWidth <= 576;
    this.boxes.forEach(box => {
      if(mobile){
        box.setAttribute('role', 'button');
        box.setAttribute('tabindex', '0');
        box.setAttribute('aria-expanded', box.hasAttribute('open') ? 'true' : 'false');
      }
      else{
        box.removeAttribute('role');
        box.removeAttribute('tabindex');
        box.removeAttribute('aria-expanded');
      }
    });
  }
}
customElements.define('footer-accordion', footerAccordion);